var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * [CLAIMS_CONTEXT]
 * purpose: Allows the user to select the external origin of a fire damage during the qualification step.
 * touches: declaration, qualification, fireDamage
 * invariants: The selected fire cause origin is synchronized with the qualification store ; available choices are provided through configured image choices
 * inputs: qualification state, fireCauseExternOrigin, FIRE_CAUSE_EXTERN_ORIGIN_IMAGE_CHOICES, change step
 * outputs: updates the fire damage qualification through updateQualification ; saves the qualification and moves to the next step through updateAndSaveQualification
 * see: @declaration/store/qualification, @declaration/constants/fireDamageConstants, @shared/types/api/claim
 */
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { UiButton, UiRadio } from '@claims-ia/design-system';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import { FireCauseExternOrigin } from '@shared/types/api/claim';
import { FIRE_CAUSE_EXTERN_ORIGIN_IMAGE_CHOICES, FIRE_CAUSE_EXTERN_ORIGIN_ANSWERS, } from '@declaration/constants/fireDamageConstants';
const claim = namespace('claim');
const qualification = namespace('qualification');
let FireCauseExternOriginQuestion = class FireCauseExternOriginQuestion extends QuestionComponent {
    constructor() {
        super(...arguments);
        this.isSaving = false;
        this.typeOfDamages = '';
    }
    get fireCauseExternOriginChoices() {
        return FIRE_CAUSE_EXTERN_ORIGIN_IMAGE_CHOICES;
    }
    get selectedValue() {
        if (this.qualification.fireCauseExternOrigin === FireCauseExternOrigin.Barbecue) {
            return FireCauseExternOrigin.Barbecue;
        }
        if (this.qualification.fireCauseExternOrigin === FireCauseExternOrigin.Lightning) {
            return FireCauseExternOrigin.Lightning;
        }
        if (this.qualification.fireCauseExternOrigin === FireCauseExternOrigin.Tinkering) {
            return FireCauseExternOrigin.Tinkering;
        }
        if (this.qualification.fireCauseExternOrigin === FireCauseExternOrigin.ForestFire) {
            return FireCauseExternOrigin.ForestFire;
        }
        if (this.qualification.fireCauseExternOrigin === FireCauseExternOrigin.dontKnow) {
            return FireCauseExternOrigin.dontKnow;
        }
        return null;
    }
    get panelTitle() {
        return this.$tc('claim.qualification.fire_cause_extern_origin.title');
    }
    get sidebarTitle() {
        const key = 'claim.qualification.fire_cause_extern_origin.sidebar_title';
        return this.$te(key) ? this.$tc(key) : this.panelTitle;
    }
    get answer() {
        if (this.qualification.fireCauseExternOrigin === FireCauseExternOrigin.Barbecue) {
            return this.$tc(FIRE_CAUSE_EXTERN_ORIGIN_ANSWERS[FireCauseExternOrigin.Barbecue]);
        }
        if (this.qualification.fireCauseExternOrigin === FireCauseExternOrigin.Lightning) {
            return this.$tc(FIRE_CAUSE_EXTERN_ORIGIN_ANSWERS[FireCauseExternOrigin.Lightning]);
        }
        if (this.qualification.fireCauseExternOrigin === FireCauseExternOrigin.Tinkering) {
            return this.$tc(FIRE_CAUSE_EXTERN_ORIGIN_ANSWERS[FireCauseExternOrigin.Tinkering]);
        }
        if (this.qualification.fireCauseExternOrigin === FireCauseExternOrigin.ForestFire) {
            return this.$tc(FIRE_CAUSE_EXTERN_ORIGIN_ANSWERS[FireCauseExternOrigin.ForestFire]);
        }
        if (this.qualification.fireCauseExternOrigin === FireCauseExternOrigin.dontKnow) {
            return this.$tc(FIRE_CAUSE_EXTERN_ORIGIN_ANSWERS[FireCauseExternOrigin.dontKnow]);
        }
        return null;
    }
    get validateText() {
        return this.$tc('claim.damage.fire.button.next_step');
    }
    get uiFireCauseExternOriginChoices() {
        return this.fireCauseExternOriginChoices.map((choice) => ({
            value: choice.value,
            label: this.$tc(choice.tradKey),
            description: choice.descriptionTradKey ? this.$tc(choice.descriptionTradKey) : undefined,
            imageSrc: choice.image,
        }));
    }
    onTypeOfDamagesClick(fireCauseExternOrigin) {
        this.updateFireDamageQualification({
            qualificationPayload: {
                fireCauseExternOrigin: fireCauseExternOrigin !== this.qualification.fireCauseExternOrigin
                    ? fireCauseExternOrigin
                    : null,
            },
        });
    }
    async validate() {
        await this.updateAndSaveFireDamageQualification({
            qualificationPayload: {
                fireCauseExternOrigin: this.qualification.fireCauseExternOrigin,
            },
            step: this.step,
        });
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], FireCauseExternOriginQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    qualification.State('qualification')
], FireCauseExternOriginQuestion.prototype, "qualification", void 0);
__decorate([
    qualification.Action('updateQualification')
], FireCauseExternOriginQuestion.prototype, "updateFireDamageQualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], FireCauseExternOriginQuestion.prototype, "updateAndSaveFireDamageQualification", void 0);
FireCauseExternOriginQuestion = __decorate([
    Component({
        components: { QuestionPanel, UiRadio, UiButton },
        props: QuestionProps,
    })
], FireCauseExternOriginQuestion);
export default FireCauseExternOriginQuestion;
